const query = (id, isPreview) => `
{
    listPaginationFilterWrapperUk(id: "${id}", preview: ${isPreview}) {
        isGeneralNews
        variant
        newsCardsListCollection {
            items {
              date
              titleLink {
                name
                url
                label
                title
                target
                scrollToElementId
                imageType
                gaEventClass
                gaEventLabel
                ariaLabel
              }
              description
              categoryLinksCollection {
                items {
                  name
                  url
                  label
                  title
                  target
                  scrollToElementId
                  imageType
                  gaEventClass
                  gaEventLabel
                  ariaLabel
                }
              }
              image {
                altText
                imageMobile {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
                imageDesktop {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
                  width
                  height
                }
              }
              variant
              video {
                internalTitle
                title
                variant
                youtubeVideoId
                posterImage {
                  altText
                  imageMobile {
                    title
                    description
                    contentType
                    fileName
                    size
                    url
                    width
                    height
                  }
                  imageDesktop {
                    title
                    description
                    contentType
                    fileName
                    size
                    url
                    width
                    height
                  }
                }
                isModal
                enableWatchLater
                isImageToggle
              }
            }
          }
  }
}

`
module.exports = { query }
